import API from "../API";
import { AxiosResponse } from "axios";

export const checkCoupon = (coupon: string): Promise<AxiosResponse> =>
  API.get(`/group/billing/coupon/${coupon}`);
